import Vue from 'vue';
import Router from 'vue-router';

// 引入 MTDUI 2.0 样式
import '@ss/mtd-vue/lib/theme2/index.css';

// 引入组件库
import MTD from '@ss/mtd-vue';

import HomePage from '@/views/home';
import LoginPage from '@/views/login';
import HomeEnPage from '@/views/home-en';
import HomeBrPage from '@/views/home-br';
import HomeSaPage from '@/views/home-sa';

Vue.use(MTD);
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
    },
    {
      path: '/banner',
      name: 'HomePage',
      component: HomePage,
    },
    {
      path: '/home-en',
      name: 'HomeEnPage',
      component: HomeEnPage,
    },
    {
      path: '/home',
      name: 'Home',
      component: HomePage,
    },
    {
      path: '/home-br',
      name: 'HomeBrPage',
      component: HomeBrPage,
    },
    {
      path: '/home-sa',
      name: 'HomeSaPage',
      component: HomeSaPage,
    },
  ],
});
